import React from "react";
import { Helmet } from "react-helmet";
import Header from "../components/Header";
import { Viewer, Worker } from "@react-pdf-viewer/core";

// Import the styles
import "@react-pdf-viewer/core/lib/styles/index.css";
export default function Helper() {
  return (
    <div>
      <Helmet>
        <script type="application/ld+json">
          {`
               "@context": "https://schema.org", 
               "@type": "Faq", 
               "mainEntity": [
                { "@type": "Question", "name": "Q1", "acceptedAnswer": 
                { "@type": "Answer", "text": "Ans1" } 
                },
                { "@type": "Question", "name": "Q2", "acceptedAnswer": 
                { "@type": "Answer", "text": "Ans2" } },
                { "@type": "Question", "name": "Q3", "acceptedAnswer": 
                { "@type": "Answer", "text": "Ans3" } },
                { "@type": "Question", "name": "Q4", "acceptedAnswer":
                 { "@type": "Answer", "text": "Ans4" } },
                 { "@type": "Question", "name": "Q5", "acceptedAnswer": 
                 { "@type": "Answer", "text": "Ans5" } },
                 { "@type": "Question", "name": "Q6", "acceptedAnswer": 
                 { "@type": "Answer", "text": "Ans6" } },
                 { "@type": "Question", "name": "Q7", "acceptedAnswer": 
                 { "@type": "Answer", "text": "Ans7" } },
                 { "@type": "Question", "name": "Q8", "acceptedAnswer": 
                 { "@type": "Answer", "text": "Ans8" } },
                 { "@type": "Question", "name": "Q9", "acceptedAnswer": 
                 { "@type": "Answer", "text": "Ans9" } },{ "@type": "Question", "name": "Q10", "acceptedAnswer": 
                 { "@type": "Answer", "text": "Ans10" } },{ "@type": "Question", "name": "Q11", "acceptedAnswer": 
                 { "@type": "Answer", "text": "Ans11" } },{ "@type": "Question", "name": "Q12", "acceptedAnswer": 
                 { "@type": "Answer", "text": "Ans12" } },{ "@type": "Question", "name": "Q13", "acceptedAnswer": 
                 { "@type": "Answer", "text": "Ans13" } }] 
          `}
        </script>
      </Helmet>
      <Header />
      <div className="container">
        <div className="pdf-content">
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
            <Viewer fileUrl="/files/help.pdf" />
          </Worker>
        </div>
      </div>
    </div>
  );
}
